<template>
  <!-- Home Banner -->
  <section class="banner-section banner-section--search">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="banner-content aos" data-aos="fade-up">
            <h1>
              {{ $t("home_t1") }}
              <span>{{ $t("home_t1_1") }}</span>
              {{ $t("home_t1_2") }}
              <span>{{ $t("home_t1_3") }}</span>
            </h1>
            <img src="@/assets/img/icons/header-icon.svg" class="header-icon" alt="header-icon" />
            <p>{{ $t("home_t2") }}</p>
          </div>
          <div class="banner-search aos" data-aos="fade-up">
            <doctor-search-bar />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="banner-img aos" data-aos="fade-up">
            <img src="@/assets/img/banner-health.png" class="img-fluid" alt="Image" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Home Banner -->

  <!-- Specialities Section -->
  <section class="specialities-section-one">
    <div class="container">
      <div class="row">
        <div class="col-md-6 aos" data-aos="fade-up">
          <div class="section-header-one section-header-slider">
            <h2 class="section-title">{{ $t("home_specialist_title") }}</h2>
          </div>
        </div>
        <div class="col-md-6 aos" data-aos="fade-up">
          <div class="owl-nav slide-nav-1 text-end nav-control"></div>
        </div>
      </div>
      <div class="owl-carousel specialities-slider-one owl-theme aos" data-aos="fade-up">
        <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
          <Slide v-for="item in IndexBanner" :key="item.id">
            <div class="item slide-content-container">
              <a href="javascript:void(0)" @click="searchby(item.Title)">
                <div class="specialities-item">
                  <div class="specialities-img">
                    <span>
                      <img
                        :src="require(`@/assets/img/specialities/${item.Image}`)"
                        alt="specialities"
                      />
                    </span>
                  </div>
                  <p>{{ item.Title }}</p>
                </div>
              </a>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>

    </div>
  </section>
  <!-- /Specialities Section -->

  <!-- Symptoms Section -->
  <section class="specialities-section-one">
    <div class="container">
      <div class="row">
        <div class="col-md-6 aos" data-aos="fade-up">
          <div class="section-header-one section-header-slider">
            <h2 class="section-title">{{ $t("home_symptoms_title") }}</h2>
          </div>
        </div>
        <div class="col-md-6 aos" data-aos="fade-up">
          <div class="owl-nav slide-nav-1 text-end nav-control"></div>
        </div>
      </div>
      <div class="owl-carousel specialities-slider-one owl-theme aos" data-aos="fade-up">
        <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
          <Slide v-for="symptom in Symptoms" :key="symptom.id">
            <div class="item slide-content-container">
              <a href="javascript:void(0)" @click="searchby(symptom.Search)">
                <div class="specialities-item">
                  <div class="specialities-img">
                    <span>
                      <img :src="require(`@/assets/img/Symptoms/${symptom.Image}`)" alt="symptoms" />
                    </span>
                  </div>
                  <p>{{ symptom.Title }}</p>
                </div>
              </a>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </section>
  <!-- /Symptoms Section -->

</template>
<script>
import AOS from "aos";
import "aos/dist/aos.css";
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexBanner from "@/assets/json/indexbanner.json";
import symptoms from "@/assets/json/symptoms.json";
import DoctorSearchBar from "@/components/frontend/DoctorSearchBar.vue";
import { readLastCity } from "@/services/cities";
import "vue3-carousel/dist/carousel.css";

export default {
  data() {
    return {
      IndexBanner: IndexBanner,
      Symptoms: symptoms,
      settings: {
        itemsToShow: 1,
        snapAlign: "center"
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center"
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center"
        },
        991: {
          itemsToShow: 3,
          snapAlign: "center"
        },
        1024: {
          itemsToShow: 6,
          snapAlign: "start"
        }
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      AOS.init();
    });
  },
  methods: {
    // Speciality/symptom tiles search within the city chosen in the search bar.
    searchby(title) {
      const query = { filter: title.trim() };
      const city = readLastCity();
      if (city) {
        query.city = city.name;
        if (city.city_id) query.city_id = city.city_id;
        if (city.locality) query.locality = city.locality;
        if (city.place_id) query.place_id = city.place_id;
      }
      this.$router.push({ name: "search", query });
    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
    DoctorSearchBar
  }
};
</script>
<style>
/* The theme's overflow: hidden would clip the search dropdowns. Clip only
   sideways, which is all the background artwork needs. */
.banner-section.banner-section--search {
  overflow: visible;
  overflow-x: clip;
  z-index: 2;
}

.banner-search {
  position: relative;
  z-index: 5;
  max-width: 640px;
  margin-top: 8px;
}
</style>
